import { slardar } from '../monitors/slardar';

export function getItem(storage: Storage, keys: string) {
  try {
    const data = storage.getItem(keys);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    slardar.sendLog('warn', {
      event: 'storage-getItem',
      keys,
      err: JSON.stringify(err),
    });
    return null;
  }
}

export function setItem(storage: Storage, keys: string, data: any) {
  try {
    storage.setItem(keys, JSON.stringify(data));
  } catch (err) {
    slardar.sendLog('error', {
      event: 'storage-setItem',
      keys,
      err: JSON.stringify(err),
    });
  }
}

export function removeItem(storage: Storage, keys: string) {
  try {
    storage.removeItem(keys);
  } catch (err) {
    // ignore
  }
}

export function key(storage: Storage, index: number) {
  try {
    return storage.key(index);
  } catch (err) {
    // ignore
    return null;
  }
}

export function clear(storage: Storage) {
  try {
    storage.clear();
  } catch (err) {
    // ignore
  }
}
